module.exports = __webpack_public_path__ + "img/banner.1aa10aa8.jpg";